import { useQuery } from '@tanstack/react-query';
import apiFactory from '@/api';
import { aiVisibilityCredits } from '@/constants';
import { isAiPackage } from '~/views/auth/billing-utils';
import { validateLog } from '~/common/utils';
import { pkgSchema } from '~/api/schemas/packages';
import { z } from 'zod/v4';
const billingApi = apiFactory.get('billing');
export const getPackagesQuery = (packageIdentity) => ({
    queryFn: async () => {
        const [queryPkg, ...allPkgs] = await Promise.all([
            packageIdentity
                ? billingApi.fetchPackageById(packageIdentity).then(validateLog(pkgSchema))
                : Promise.resolve(undefined),
            ...aiVisibilityCredits.map(({ value }, index) => {
                return billingApi
                    .fetchPackages({ params: { quantity: value } })
                    .then(validateLog(z.object({ data: z.array(pkgSchema) })))
                    .then((res) => {
                    return index === 0
                        ? res.data.data.map((pkg) => (isAiPackage(pkg) ? { ...pkg, quantity: value } : pkg))
                        : res.data.data.filter(isAiPackage).map((pkg) => ({ ...pkg, quantity: value }));
                })
                    .catch(() => []);
            }),
        ]);
        const flattenedPackages = allPkgs.flat();
        if (queryPkg && !flattenedPackages.some((pkg) => pkg.package_identity === queryPkg.data?.package_identity)) {
            flattenedPackages.push(queryPkg.data);
        }
        return flattenedPackages;
    },
    queryKey: ['packages'],
});
export const usePackages = (packageIdenttiy) => useQuery(getPackagesQuery(packageIdenttiy));
